import React from 'react';
import PropTypes from 'prop-types';

import Marker from './Marker.jsx';
import { getThreeTransformFromArray } from '../../utils/ThreeTransformConverter';


const womanFurView13Hotspot = '60f0d2f8c584ff71d102cc1a';
const womanFurView13BackHotspot = '61003664d4c173fde954d61e';
const womanView15Hotspot = '60f5f928f2e43cc4d45f7701';
const womanView15BackHotspot = '6100483dd4c173fde954d64b';
const womanView16Hotspot = '60f0cd06f2e43cc4d45f73fc';
const womanView17Hotspot = '60f5fc83f2e43cc4d45f7703';
const womanView18Hotspot = '60f6034cc584ff71d102cea0';
const menView25Hotspot = '60f608d4f2e43cc4d45f7705';
const menView26Hotspot = '60f0d651f2e43cc4d45f7413';
const menView27Hotspot = '60f60fabf2e43cc4d45f7708';
const bookAnAppointmentView28Hotspot = '60f0c06fc584ff71d102cbb8';
const bookAnAppointmentView29Hotspot = '60f0c0edc584ff71d102cbbe';


const PreviewTextBox = ({ hoveredSpriteUrl, showPreviewTextBox, primaryColor, secondaryColor, transform, hotspotId }) => {
    const threeTransform = getThreeTransformFromArray(transform);
    const textBoxSize = ((hotspotId === womanFurView13Hotspot) ? [7.17, 2.5] :
                        (hotspotId === womanFurView13BackHotspot) ? [7.17, 2.5] :
                        (hotspotId === womanView15Hotspot) ? [7.17, 2.5] :
                        (hotspotId === womanView15BackHotspot) ? [7.17, 2.5] :
                        (hotspotId === womanView16Hotspot) ? [7.17, 2.5] :
                        (hotspotId === womanView17Hotspot) ? [7.17, 2.5] :
                        (hotspotId === womanView18Hotspot) ? [7.17, 2.5] :
                        (hotspotId === menView25Hotspot) ? [7.17, 2.5] :
                        (hotspotId === menView26Hotspot) ? [7.17, 2.5] :
                        (hotspotId === menView27Hotspot) ? [7.17, 2.5] :
                        (hotspotId === bookAnAppointmentView28Hotspot) ? [6.97, 1] :
                        (hotspotId === bookAnAppointmentView29Hotspot) ? [6.97, 1] :
                        [threeTransform.elements[0],threeTransform.elements[5]]);
    // Setting custom box size in transformation matrix to determine size of text box component
    threeTransform.elements[0] = textBoxSize[0];
    threeTransform.elements[5] = textBoxSize[1];
    
    const transform3d = threeTransform.elements;

    if (showPreviewTextBox) {
        return (
            <Marker
                transform={transform3d}
                colliderTransform={transform}
                normalSpriteUrl={hoveredSpriteUrl}
                hoveredSpriteUrl={hoveredSpriteUrl}
                showVisual={showPreviewTextBox}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
            />
        );
    }
    else {
        return(
            <React.Fragment />
        );
    }
}

PreviewTextBox.propTypes = {
    transform: PropTypes.array,
    colliderTransform: PropTypes.array,
    showVisual: PropTypes.bool,
    hoveredSpriteUrl: PropTypes.string,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string
};

export default PreviewTextBox;
